export default "__VITE_ASSET__CljmDCOy__"